module.exports = __webpack_public_path__ + "media/src/website/images/locations/tegernsee/tegernsee_03-23eba8e5eb7db261253a64dd03f39a9b.jpg";